import { toJourneyIndicators } from '@modules/client-journey/services/journey-adapters'

// Com default sempre: nunca devolvem undefined, para o componente não precisar
// de guard a cada leitura.
export default {
  template: (state) => state.template,
  loading: (state) => state.loading,
  loadingSummaries: (state) => state.loadingSummaries,
  error: (state) => state.error,
  journeyDoCliente: (state) => (clientId) => state.byClientId[clientId] || null,
  summaryDoCliente: (state) => (clientId) => state.summaries[clientId] || null,
  summaries: (state) => Object.keys(state.summaries).map((id) => state.summaries[id]),
  // Os do backend vencem. O cálculo local sobre os resumos JÁ CARREGADOS é
  // fallback: com a lista paginada ou filtrada ele conta só a página, e não a
  // carteira inteira — por isso a rota existe.
  indicadores: (state, getters) =>
    state.indicators || toJourneyIndicators(getters.summaries),
}
